export enum PayType {
  CUSTOM = 'CUSTOM',
  BALANCE = 'BALANCE',
  CASHBACK = 'CASHBACK'
}
